export const enum ChatViewMode {
    Normal = 'Normal',
    Search = 'Search',
    Menu = 'Menu',
    Gallery = 'Gallery',
    Settings = 'Settings',
    Favorites = 'Favorites',
}
